import LocalStore from '@/providers/local-store';

export default new LocalStore( 'upi-pp-bookmarks' );
